import { Button, Modal } from 'antd';
import { useState } from 'react';
import { ContainerFooter, Content, ModalContainer } from './styles';

import owlImg from '../../../../assets/img/pet/corujaProfessora.png';
import { apiNode } from '../../../../services/api';

interface LeagueParticipants {
  id: number;
  isAdmin: boolean;
  pontos: number;
  username: string;
  foto: string;
}

interface KickPlayerModalProps {
  isOpen: boolean;
  participant: LeagueParticipants;
  closeModal: () => void;
  updateParticipantsList: (id: number) => void;
}

export const KickPlayerModal = ({
  closeModal,
  isOpen,
  participant,
  updateParticipantsList,
}: KickPlayerModalProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleDeletePlayer = async () => {
    try {
      setIsLoading(true);
      await apiNode.delete(`/ligas/participantes/${participant.id}`);
      updateParticipantsList(participant.id);

      setIsLoading(false);
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  };

  return (
    <ModalContainer>
      <Modal
        visible={isOpen}
        onCancel={closeModal}
        bodyStyle={{ padding: 0 }}
        footer={[
          <ContainerFooter key="teste">
            <Button
              type="primary"
              onClick={handleDeletePlayer}
              loading={isLoading}
              disabled={isLoading}
              key="exitLeague"
            >
              Sim
            </Button>
            ,
            <Button
              type="primary"
              onClick={closeModal}
              disabled={isLoading}
              key="stayInLeague"
            >
              Não
            </Button>
            ,
          </ContainerFooter>,
        ]}
      >
        <Content>
          <h1>ATENÇÃO!</h1>

          <img src={owlImg} alt="Imagem de uma coruja" />

          <span>
            <p>
              Tem certeza que você deseja expulsar o jogador
              <strong> {participant.username}</strong>?
            </p>
          </span>
        </Content>
      </Modal>
    </ModalContainer>
  );
};
